import { GetProxiesByOrderItemResponse } from "../../../../common/api/orders-api/proxy/GetProxiesByOrderResponse";
import { getLanguageDisplayName } from "../../../../common/types/Language";
import { mapNumberToOrderProxyType, OrderProxyType } from "../../../common/types/OrderProxyType";

export interface OrderProxiesListingItem {
    filePath: string;
    proxyType: string;
    language?: string;
}

export const mapToOrderProxiesListingItem = (response: GetProxiesByOrderItemResponse): OrderProxiesListingItem => {
    const proxyType = OrderProxyType[mapNumberToOrderProxyType(response.type)];

    return {
        filePath: response.path,
        proxyType,
        language: response.language ? getLanguageDisplayName(response.language) : undefined
    };
};
